module.exports = __webpack_public_path__ + "static/media/Competitor.1cf0363f.svg";